<ion-toolbar class="custom-top-navigation" *ngIf="data?.length > 0">
  <div class="custom-top-navigation__bar">
    <ng-container
      *ngFor="let operative of data.length > 4 ? data.slice(0, 3) : data"
    >
      <button
        class="custom-top-navigation__button"
        matRipple
        (click)="operative.handler ? operative.handler() : null"
      >
        <ion-icon
          class="option-icon mapfre-mb-s"
          color="white"
          [src]="operative.img"
        ></ion-icon>
        <ion-label class="white mapfre-fs-xxs mapfre-fw-500">
          {{ operative.title | translate }}
        </ion-label>
      </button>
      <mat-divider [vertical]="true"></mat-divider>
    </ng-container>
    <ng-container *ngIf="data.length > 4">
      <button
        class="custom-top-navigation__button"
        matRipple
        [matMenuTriggerFor]="moreMenu"
      >
        <img
          class="option-icon mapfre-mb-s"
          src="assets/images/client-area/policy-detail/more.svg"
          alt="more"
        />
        <ion-label class="white mapfre-fs-xxs mapfre-fw-500">Más</ion-label>
      </button>
      <mat-divider [vertical]="true"></mat-divider>
      <mat-menu class="custom-top-navigation__popover" #moreMenu="matMenu">
        <button
          mat-menu-item
          class="popover-item df ai-c"
          matRipple
          *ngFor="let operative of data.slice(3)"
          (click)="operative.handler ? operative.handler() : null"
        >
          <ion-icon
            class="mapfre-mr-sm"
            color="medium-dark"
            [src]="operative.img"
          ></ion-icon>
          <span>{{ operative.title | translate }}</span>
        </button>
      </mat-menu>
    </ng-container>
  </div>
</ion-toolbar>
